import { t } from "@web-monorepo/i18n/macro";
import createAction from "@web-monorepo/infra/createAction";
import createActionCreator from "@web-monorepo/infra/createActionCreator";
import { getImageSrc } from "@web-monorepo/static-assets";
import { AppMetadata } from "src/pods/toolkitData/components/EditableSetup";

const icon = getImageSrc("toolkit/src/pods/radio/assets/logo.svg");

export const appMetadataRadio = (): AppMetadata => ({
  href: "radio",
  title: t`Music`,
  variant: "radio",
  icon,
});

type Track = {
  src: string;
};
export type RadioChannel = {
  title: string;
  icon: string;
  tracks: Track[];
};
export type Radio = {
  mountPoint: string;
  classId: string;
  synced: boolean;
  channel?: RadioChannel;
  currentTrackIndex: number;
  playing: boolean;
};

export const SEND_RADIO = createAction("SEND_RADIO");
export const RECEIVE_RADIO = createAction("RECEIVE_RADIO");

export type SendRadioProps = {
  channel?: RadioChannel | null;
  currentTrackIndex?: number;
  playing?: boolean;
};
export const sendRadio = createActionCreator(SEND_RADIO, ({ channel, currentTrackIndex, playing }: SendRadioProps) => ({
  synced: true,
  channel,
  currentTrackIndex,
  playing,
}));
